import React from "react";
import FeatureDetailLayout from "../components/FeatureDetailLayout";

export default function Nutrition() {
  return (
    <FeatureDetailLayout
      seoTitle="Nutrition"
      seoPath="/nutrition"
      noindex
      eyebrow="Nutrition"
      title="Fuel your body with"
      highlight="precision"
      description="Jollof Fit Kingdom connects what you eat to how you perform and recover. Nutrition tracking turns macros and calories into meaningful, personalized guidance aligned with your goals."
      benefits={[
        { icon: "Apple", title: "Macro tracking", desc: "Track calories, protein, carbs and fats with targets that adapt to your training and goals." },
        { icon: "Utensils", title: "Fast food logging", desc: "Log meals quickly with smart suggestions based on your habits and preferences." },
        { icon: "Flame", title: "Energy balance", desc: "Understand your true energy needs with data pulled from activity and body composition." },
        { icon: "Zap", title: "Performance link", desc: "See how nutrition choices affect your training, recovery and Kingdom Score." },
        { icon: "Droplets", title: "Hydration tracking", desc: "Stay optimally hydrated with reminders informed by your activity and day." },
        { icon: "CalendarClock", title: "Meal planning & reminders", desc: "Schedule meals and get nutrition reminders so you stay on target throughout the day." },
      ]}
      howItWorks={[
        { title: "Set your goal", desc: "Your personalized macro and calorie targets are calculated for your objective." },
        { title: "Log your meals", desc: "Quick logging keeps your nutrition data accurate and effortless." },
        { title: "Connect the dots", desc: "See how what you eat shapes your performance, recovery and results." },
      ]}
    />
  );
}
